export default __webpack_public_path__ + "static/regular-cabin-outside-693296a66ce189f88043c7a6ea9cc8e4.jpg";